import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiFlatButton from 'material-ui/FlatButton';
import styles from './styles';
import './index.css';
import stepOneIcons from './img/step-one-icons.svg';

export default class ManualActivationStepOne extends Component {
  static propTypes = {
    moveForward: PropTypes.func,
  }

  render() {
    return (
      <div className="activate-step-one">
        <div className="activate-step-content">
          <p>
            <span className="semibold">Step 1.</span> Locate one of these buttons on your console.
            <img className="step-one-icons" src={ stepOneIcons } alt="Examples of possible Bluetooth buttons on your machine" />
          </p>
        </div>

        <div className="activate-step-buttons clearfix">
          <MuiFlatButton
            className="activate-step-next"
            label="Next"
            labelStyle={ styles.nextLabelStyle }
            hoverColor="transparent"
            primary={ true }
            rippleColor="transparent"
            style={ styles.flatButtonStyle }
            onClick={ this.props.moveForward }
          />
        </div>
      </div>
    );
  }
}
